
import Vue from "vue";
import { Task, TaskStatus } from "../../models/tasks/task";
import { Folder } from "../../models/tasks/folder";
import { UserInfo } from "../../models/dossier/user-info";
import { TaskAssignedUser } from "../../models/tasks/assigned-user";
import { ISelectItem } from "winfakt-vue-components";
import { FolderUser } from "../../models/tasks/folder-user";
import { DossierService } from "../../services/dossier-service";
import AppUserSearch from "../UserSearch.vue";
import AppTaskPriorityChips from "./TaskPriorityChips.vue";

export default Vue.extend({
	data() {
		return {
			users: DossierService.users as UserInfo[],
			wAttributes: {
				contentStyle: ({isHovered}:any) => ({
					color: "#000",
					opacity: 0.2,
					...(isHovered && {
						cursor: "not-allowed",
						backgroundColor: "transparent",
					}),
				}),
			}
		};
	},
	props: {
		value: {
			type: Object as ()=>Task,
			required: true
		},
		folders: {
			type: Array as ()=>FolderUser[],
			required: true
		}
	},
	computed: {
		folderItems():ISelectItem<number>[] {
			return this.folders.map(f => {
				return {
					text: (f.Folder as Folder).Name,
					value: f.FolderID
				};
			});
		},
		taskStatuses(): ISelectItem<number>[] {
			return [TaskStatus.PENDING, TaskStatus.UNCONFIRMED, TaskStatus.COMPLETED].map((val)=>{
				return {
					value: val,
					text: this.$ct("models.TaskStatuses." + val).toString()
				};
			});
		},
		minDate(): Date {
			return new Date();
		},
		addableUsers(): UserInfo[] {
			return this.users.filter(u => this.fullAssignedUsers.find(f => f.ID == u.ID) == null);
		},
		fullAssignedUsers(): UserInfo[] {
			return this.value.AssignedUsers.map(u => {
				return this.users.find(f => f.ID == u.UserID) as UserInfo;
			}).filter(f => f != undefined);
		},
	},
	methods: {
		addUser(user: UserInfo) {
			let a = new TaskAssignedUser({TaskID: this.value.ID, UserID: user.ID});
			this.value.AssignedUsers.push(a);
		},
		removeUser(i: number) {
			this.value.AssignedUsers.splice(i, 1);
		},
		removeDueDate() {
			this.value.DueDate = new Date(0);
		}
	},
	async created() {
		this.users = await DossierService.getUsers();
	},
	components: {
		AppUserSearch,
		AppTaskPriorityChips
	},
	i18nEx: {
		componentPrefix: "components.tasks"
	}
});
